import styled from "styled-components";

import { Flex } from "emoreg";
import { spaces } from "emoreg/const";

export const ZoneContainer = styled(Flex)`
  width: 100%;
  margin: ${spaces[4]} 0;
`;
ZoneContainer.displayName = "ZoneContainer";
